module.exports = __webpack_public_path__ + "img/tostitos.26e5b3fa.png";